module.exports = __webpack_public_path__ + "img/inactivecodingtest.89efd773.svg";